import DeactivatedUser from './DeactivatedUser';

export default DeactivatedUser;
